export default __webpack_public_path__ + "static/media/platform-select.f51a7c53.svg";